export enum HomeMode {
  View,
  Reorder,
}
